export default "__VITE_ASSET__DFUafG9t__"